import _toConsumableArray from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { LogLevel } from './enums/log_level';
import { DummyLogger } from './_internal/dummy_logger';

var ConsoleLogger =
/*#__PURE__*/
function () {
  function ConsoleLogger(tag) {
    var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return false;
    };

    _classCallCheck(this, ConsoleLogger);

    this._tagParts = [];
    this._tagText = '';
    this._enabled = true;
    this._level = LogLevel.NONE;
    this.tag = '';
    this.description = '';

    this._predicate = function () {
      return false;
    };

    this.tag = tag;
    this.description = description;
    this._predicate = predicate;
    this._tagParts = tag.split('.');
    this._tagText = "[".concat(tag, "]");
  }

  _createClass(ConsoleLogger, [{
    key: "_print",
    value: function _print(levelName, logLevel, args) {
      var _console;

      if (!this._enabled && !(this._level & logLevel)) {
        return;
      }

      var logObj = {
        args: args,
        type: levelName,
        tag: this.tag
      };

      if (this._predicate(logObj)) {
        return;
      }
      /* eslint-disable-next-line no-console */


      (_console = console)[levelName].apply(_console, [this._tagText].concat(_toConsumableArray(args)));
    }
  }, {
    key: "matchesTag",
    value: function matchesTag(tag) {
      var _tag = Array.isArray(tag) ? tag : tag.split('.');

      var tagParts = this._tagParts;

      if (_tag.length > tagParts.length) {
        return false;
      }

      for (var i = 0, l = _tag.length; i < l; i++) {
        if (_tag[i] === '*' && tagParts[i]) {
          // matches anything
          continue;
        }

        if (_tag[i] !== tagParts[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "setLevel",
    value: function setLevel(level) {
      var value = 0;

      switch (level) {
        case 'error':
          value = LogLevel.ERROR;
          break;

        case 'warn':
          value = LogLevel.WARN | LogLevel.ERROR;
          break;

        case 'info':
          value = LogLevel.INFO | LogLevel.WARN | LogLevel.ERROR;
          break;

        case 'debug':
          value = LogLevel.DEBUG | LogLevel.INFO | LogLevel.WARN | LogLevel.ERROR;
          break;

        case 'log':
        default:
          value = LogLevel.LOG | LogLevel.DEBUG | LogLevel.INFO | LogLevel.WARN | LogLevel.ERROR;
          break;
      }

      this._level = value;
    }
  }, {
    key: "enable",
    value: function enable() {
      this._enabled = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._enabled = false;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      this._print('log', LogLevel.LOG, _args);
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, _args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        _args[_key2] = arguments[_key2];
      }

      this._print('debug', LogLevel.DEBUG, _args);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, _args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        _args[_key3] = arguments[_key3];
      }

      this._print('info', LogLevel.INFO, _args);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, _args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        _args[_key4] = arguments[_key4];
      }

      this._print('warn', LogLevel.WARN, _args);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, _args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        _args[_key5] = arguments[_key5];
      }

      this._print('error', LogLevel.ERROR, _args);
    }
  }]);

  return ConsoleLogger;
}();

export var DebugLogger = typeof process !== 'undefined' && process.env.DEBUG === 'true' ? ConsoleLogger : DummyLogger;